import React from "react";

interface DoubleCircleIconProps {
  icon: React.ReactElement;
  type?: "success" | "warning" | "error" | "primary" | "gray";
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  customColors?: {
    outer?: string;
    inner?: string;
    icon?: string;
  };
}

const DoubleCircleIcon = ({
  icon,
  type = "primary",
  size = "md",
  customColors,
}: DoubleCircleIconProps) => {
  const colorScheme = customColors || colors[type];

  return (
    <div className={`relative ${sizes[size].outer}`}>
      <div
        className={`absolute top-0 left-0 ${sizes[size].outer} flex justify-center items-center rounded-full ${colorScheme.outer}`}
      />
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${sizes[size].inner} flex justify-center items-center rounded-full ${colorScheme.inner}`}
      />
      {React.cloneElement(icon, {
        className: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${sizes[size].icon} ${colorScheme.icon}`,
      })}
    </div>
  );
};

const sizes = {
  sm: {
    outer: "w-[36px] h-[36px]",
    inner: "w-[24px] h-[24px]",
    icon: "w-[16px] h-[16px]",
  },
  md: {
    outer: "w-[48px] h-[48px]",
    inner: "w-[36px] h-[36px]",
    icon: "w-[24px] h-[24px]",
  },
  lg: {
    outer: "w-[56px] h-[56px]",
    inner: "w-[44px] h-[44px]",
    icon: "w-[28px] h-[28px]",
  },
  xl: {
    outer: "w-[64px] h-[64px]",
    inner: "w-[52px] h-[52px]",
    icon: "w-[32px] h-[32px]",
  },
  "2xl": {
    outer: "w-[88px] h-[88px]",
    inner: "w-[76px] h-[76px]",
    icon: "w-[36px] h-[36px]",
  },
};

const colors = {
  success: {
    outer: "bg-green-50",
    inner: "bg-green-100",
    icon: "text-green-600",
  },
  warning: {
    outer: "bg-yellow-50",
    inner: "bg-yellow-100",
    icon: "text-yellow-600",
  },
  error: {
    outer: "bg-red-50",
    inner: "bg-red-100",
    icon: "text-red-600",
  },
  primary: {
    outer: "bg-primary opacity-25",
    inner: "bg-primary opacity-25",
    icon: "text-primary",
  },
  gray: {
    outer: "bg-gray-50",
    inner: "bg-gray-100",
    icon: "text-gray-600",
  },
};

export default DoubleCircleIcon;
